import { render, staticRenderFns } from "./userDefinedRoleId8.vue?vue&type=template&id=6a4fb453&"
import script from "./userDefinedRoleId8.vue?vue&type=script&lang=js&"
export * from "./userDefinedRoleId8.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a4fb453')) {
      api.createRecord('6a4fb453', component.options)
    } else {
      api.reload('6a4fb453', component.options)
    }
    module.hot.accept("./userDefinedRoleId8.vue?vue&type=template&id=6a4fb453&", function () {
      api.rerender('6a4fb453', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/uiCustom/userDefinedRoleId8.vue"
export default component.exports